import {
  SET_MAJOR_LIST
} from '/mutation-types'
import api from 'service'
const state = {
  majorList: {
    inventory: [], // 清单 专业列表
    quota: [], // 定额 专业列表
    combination: [], // 组价 专业列表
    material: [] // 人材机 专业列表
  },
  regionList: {
    inventory: [], // 清单 地区列表
    quota: [], // 定额 地区列表
    combination: [], // 组价 地区列表
    material: [] // 人材机 地区列表
  }
}

const mutations = {
  [SET_MAJOR_LIST] (state, {type, list, region}) {
    if (type) {
      state.majorList[type] = list || []
      state.regionList[type] = region || []
    }
  }
}

const actions = {
  getMajorAndRegion ({commit, state}, name) {
    const startFetch = (type) => {
      return new Promise((resolve, reject) => {
        if (api[type] && api[type].getMajorAndRegion) {
          console.log(type)
          api[type].getMajorAndRegion().then(res => {
            if (+res.code === 200 && res.data) {
              const list = res.data.catalogList || []
              const region = res.data.regionList || []
              commit(SET_MAJOR_LIST, {type, list, region})
              resolve(res.data)
            }
          }).catch((e) => {
            reject(e)
          })
        } else {
          resolve({})
        }
      })
    }
    if (name) {
      return startFetch(name)
    } else {
      for (const key in state.majorList) {
        startFetch(key)
      }
    }
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
